import React from 'react';
import {observer} from 'mobx-react';
import {AppHeaderCrossBrandListBox} from "./boxes/app-header-cross-brand-list/app-header-cross-brand-list.box";
import {CyClass} from "../../../../../common/cy-classes";
import {IMenuItemRenderer} from '../../../../services/menu-items-common/renderer/menu-item.renderer.interface';
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";

interface AppHeaderCrossBrandsComponentProps extends ComponentServicesPick<'header'> {

}

const ComponentBody: React.FC<AppHeaderCrossBrandsComponentProps> = observer((props) => {
  const _renderCrossBrandLinks = (sites: IMenuItemRenderer[]) => {
    return (
        <React.Fragment>
          {sites.map(menuItem => <React.Fragment key={menuItem.key}>
            {menuItem.renderMenuItem()}
          </React.Fragment>)}
        </React.Fragment>
    );
  }

  let crossBrandsMenuItems = props.header.getCrossBrandsMenuItems();
  if (crossBrandsMenuItems.length === 0) {
    return null;
  }
  return (
      <AppHeaderCrossBrandListBox className={CyClass('cy-cross-brand-list')}>
        {_renderCrossBrandLinks(crossBrandsMenuItems)}
      </AppHeaderCrossBrandListBox>
  );

})
export const AppHeaderCrossBrandsComponent = withServices(ComponentBody, ['header']);